import React from "react";
import styled from "styled-components";
import ErrorIcon from "assets/svg/CrossIconWithCircle";
import CheckIcon from "assets/svg/DefaultGreyCheckIcon";

const PasswordErrorMsg = (props) => {
  const locale = props.locale;
  let arr = [
    locale("passwordUpperCase"),
    locale("passwordLowerCase"),
    locale("passwordNumeral"),
    locale("passwordSymbol"),
    locale("passwordMinLength"),
  ];
  return (
    <ErrorContainer>
      {arr.map((msg, i) => (
        <p
          key={i}
          className={
            !props.value || props.value.length === 0
              ? "grey"
              : props?.error?.indexOf(msg) !== -1
              ? "red"
              : "green"
          }
        >
          {!props.value || props.value.length === 0 ? (
            <CheckIcon />
          ) : props?.error?.indexOf(msg) !== -1 ? (
            <ErrorIcon />
          ) : (
            <CheckIcon color="#4EAD8B" />
          )}
          {msg}
        </p>
      ))}
    </ErrorContainer>
  );
};

export default PasswordErrorMsg;

const ErrorContainer = styled.div`
  display: grid;
  gap: 6px;
  p {
    font-size: 13px;
    line-height: 16px;
    display: flex;
    align-items: center;
    gap: 6px;
  }
  .grey {
    color: #939292;
  }
  .red {
    color: #d90d0d;
  }
  .green {
    color: #4ead8b;
  }
`;
